import { motion } from "framer-motion";
import FunctionItem from "./FunctionItem";

const container = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.5,
      delayChildren: 0.3, // このアニメーションの発火を、親のアニメーションからどれくらい遅らせるか
      staggerChildren: 0.1, // 子供同士のアニメーションのずれをどれくらいにするか
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 30, transition: { duration: 1 } },
  visible: { opacity: 1, y: 0 },
};

const FunctionItems = (): JSX.Element => {
  return (
    <motion.div
      className="grid laptop:grid-cols-3 gap-40 laptop:gap-80"
      variants={container}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
    >
      {[
        {
          icon: "/imgs/maker_lp/icon_future01.svg",
          name: "メーカー専用ページ",
          description:
            "TECTURE上の貴社メインページ。WEBページをつくるような感覚で簡単にカスタマイズできます。",
        },
        {
          icon: "/imgs/maker_lp/icon_future02.svg",
          name: "製品登録",
          description:
            "登録数は無制限。製品を登録しておけば設計者による検索や、事例写真へのピンづけが可能に。",
        },
        {
          icon: "/imgs/maker_lp/icon_future03.svg",
          name: "施工事例写真登録",
          description:
            "貴社が保有する施工事例写真に製品情報をピン付けして投稿することができます。",
        },
        {
          icon: "/imgs/maker_lp/icon_future04.svg",
          name: "リスト作成・掲載",
          description:
            "さまざまな切り口でリストを作成し、オンライン上で発信いただけます。",
        },
        {
          icon: "/imgs/maker_lp/icon_future05.svg",
          name: "サンプル一括請求",
          description:
            "事前にTECTURE倉庫に預けるだけ。サンプル請求をした顧客のリード情報は貴社にお渡しします。",
        },
        {
          icon: "/imgs/maker_lp/icon_future06.svg",
          name: "アナリティクス",
          description:
            "月間の製品PVなどのデータを取得。設計者の反響や興味関心の把握などに役立ちます。",
        },
      ].map((value, index) => (
        <motion.div key={index} variants={item}>
          <FunctionItem value={value} />
        </motion.div>
      ))}
    </motion.div>
  );
};
export default FunctionItems;
